import React from 'react'
import { makeStyles } from '@material-ui/core'

import { Typography } from 'src/modules/ui'
import { formatPrice } from 'src/utils'

const useStyles = makeStyles(theme => ({
  table: {
    borderSpacing: 0,
    width: '100%',
    '& td': {
      display: 'table-cell',
      paddingBottom: theme.spacing(1),
    },
    '& td:last-child': {
      textAlign: 'right',
    },
    [theme.breakpoints.up('tablet')]: {
      maxWidth: '300px',
    },
  },
  tableContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
  },
}))

const InvoiceTotalsInputs = ({ invoice }) => {
  const classes = useStyles()

  const {
    deliveryCharge,
    otherCharge,
    discount,
    creditNote,
    goodsTotal,
    subTotal,
    vatTotal,
    total,
  } = invoice

  return (
    <div className={classes.tableContainer}>
      <table className={classes.table}>
        <tbody>
          <tr>
            <td>
              <Typography variant="h5">Goods Total</Typography>
            </td>
            <td>{formatPrice(goodsTotal)}</td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">Delivery Charge</Typography>
            </td>
            <td>{formatPrice(deliveryCharge)}</td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">Other Charge</Typography>
            </td>
            <td>{formatPrice(otherCharge)}</td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">Discount</Typography>
            </td>
            <td>{formatPrice(discount)}</td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">Subtotal</Typography>
            </td>
            <td>{formatPrice(subTotal)}</td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">VAT</Typography>
            </td>
            <td>{formatPrice(vatTotal)}</td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">Credit Note</Typography>
            </td>
            <td>{formatPrice(creditNote)}</td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">Total</Typography>
            </td>
            <td>{formatPrice(total)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default InvoiceTotalsInputs
